import script from "./AssessmentInfrastructure.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentInfrastructure.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentInfrastructure.vue?vue&type=style&index=0&id=2fecb340&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fecb340"]])

export default __exports__